export default __webpack_public_path__ + "static/media/user-account.8b225a2d.svg";